/**
 * Returns a promise that resolves after a specified amount of time.
 * @param {number} msec - The amount of time to wait before resolving the promise, in milliseconds.
 * @returns {Promise} A promise that resolves after a specified amount of time
 * */
export function delay(msec: number): Promise<void> {
    return new Promise((resolve) => {
        window.setTimeout(resolve, msec);
    });
}
